export default "__VITE_ASSET__Vy3_KHkI__"